import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers:{'Access-Control-Allow-Origin': '*'}
  
});

  export const api = {
  get(endpoint){
    return axiosInstance.get(endpoint);
  }
  
}
